import type { FormatterPreset } from "@imminently/decisively-core";
import React from "react";
import type { AttributeOption } from "../types";

/**
 * Feeds the live attribute list to the `AttributeTokenView` node view.
 *
 * A node only stores its `attributeKey`; the chip resolves the label (and the
 * type / formatter menu) from here, and reuses the same values when it opens the
 * shared picker to edit itself. Tiptap's React node views render as portals
 * inside the `<EditorContent>` tree, so a provider wrapped around the editor
 * reaches them through normal context.
 */
export interface AttributeTokenContextValue {
  attributes: AttributeOption[];
  groupOrder: string[];
  /** Override the formatter menu per attribute. Defaults to the type's standard set. */
  formatterOptionsFor?: (attribute: AttributeOption) => FormatterPreset[];
  /** Offer the editor-only "Display as" short label (`as "label"`). Renderers ignore it; off by default. */
  allowCustomLabel?: boolean;
}

const AttributeTokenContext = React.createContext<AttributeTokenContextValue>({
  attributes: [],
  groupOrder: [],
  allowCustomLabel: false,
});

export const AttributeTokenProvider = AttributeTokenContext.Provider;

export const useAttributeTokenContext = (): AttributeTokenContextValue => React.useContext(AttributeTokenContext);
